import { doLog, getVeEnvLoc, initPage, initVeEnvLoc, setVeEnvLoc } from '@/js/veb.js'
import veAmplify from '@/js/veamplify.js'
import { fetchAuthSession } from 'aws-amplify/auth'

let appInstance = null
const setAppInstance = (instance) => { // setAppInstance is called in main.js
  appInstance = instance
}

const displayToast = (message, dbg = false) => {
  const fn = 'displayToast'
  doLog(fn, { message }, dbg)
  if (!appInstance?.config?.globalProperties?.$toasted) {
    console.warn('Toast plugin not ready or app instance not set.')
    return
  }
  appInstance.config.globalProperties.$toasted.show(message, { type: 'error', theme: 'outline', position: 'top-right', duration: 2000 })
}

const postAmplifyAuth = async (dbg = false) => {
  const fn = 'postAmplifyAuth'
  dbg = true
  doLog(fn, { info: 'starting post-auth process' }, dbg)
  try {
    const session = await fetchAuthSession()
    doLog(fn, { info: 'fetchAuthSession returned:', session }, dbg) // Added this line
    veAmplify.setSession(session, dbg)
    if (veAmplify.getSession()) {
      doLog(fn, { info: 'session established successfully' }, dbg)
      doLog(fn, { veCognitoEmail: await veAmplify.getCognitoEmail() }, dbg)
    } else {
      doLog(fn, { error: 'failed to establish session after auth redirect', sessionReturned: session }, true) // Added sessionReturned
    }
  } catch (e) {
    doLog(fn, { info: 'error during post-auth process', error: e }, true)
  }
}

const initPageVue = async (cfg, dbg = false) => {
  const fn = 'initPageVue'
  dbg = true
  let veEnvLoc = getVeEnvLoc(dbg)
  const currentUrl = window.location.href // Changed to let
  const isLocalhost = window.location.hostname === 'localhost'
  doLog(fn, { veEnvLoc, isLocalhost, windowLocationHostname: window.location.hostname }, dbg)
  // --- Start URL cleanup for Amplify redirect ---
  // if (currentUrl.includes('?code=') && currentUrl.includes('#/')) {
  //   const cleanUrl = currentUrl.split('#/')[0]
  //   doLog(fn, { info: 'Cleaning up URL for Amplify redirect', originalUrl: currentUrl, cleanUrl }, dbg)
  //   window.history.replaceState({}, document.title, cleanUrl)
  //   currentUrl = cleanUrl // Update currentUrl for subsequent checks
  // }
  // --- End URL cleanup ---
  if (isLocalhost) {
    veEnvLoc = 've-cd-dev-in-1'
    setVeEnvLoc(veEnvLoc, dbg)
    doLog(fn, { info: 'Localhost detected, setting veEnvLoc to DEV', veEnvLoc }, dbg)
  }
  // ve.initGlobalVars() needs to be called from main.js
  initPage(dbg)
  doLog(fn, { veEnvLoc, currentUrl }, dbg)
  if (await veAmplify.isNotAuthenticated(dbg) && !currentUrl.includes('code=')) {
    if (isLocalhost) {
      veEnvLoc = 've-cd-dev-in-1'
      setVeEnvLoc(veEnvLoc, dbg)
      doLog(fn, { info: 'No veEnvLoc from URL, defaulting to DEV and calling startCognitoLogin', veEnvLoc }, dbg)
    }
    veAmplify.startCognitoLogin(veEnvLoc, dbg)
    await postAmplifyAuth(dbg)
  }
  // Always call postAmplifyAuth if a code is present in the URL,
  // or if already authenticated, or if localhost.
  // This ensures Amplify processes the redirect code without being blocked by isAuthenticated().
  if (currentUrl.includes('code=')) { // || isLocalhost || veAmplify.isAuthenticated(dbg)) {
    doLog(fn, { info: 'calling initVeEnvLoc(...', veEnvLoc }, dbg)
    initVeEnvLoc(veEnvLoc, cfg, dbg)
    doLog(fn, { info: 'calling initAmplifyConfig(...', veEnvLoc }, dbg)
    veAmplify.initAmplifyConfig(veEnvLoc, dbg)
    doLog(fn, { info: 'calling postAmplifyAuth(...', veEnvLoc }, dbg)
    await postAmplifyAuth(dbg)
  }
}

export { displayToast, initPageVue, postAmplifyAuth, setAppInstance }
